<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="dates"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="dateRangeText"
        label="Seleccione un rango de fecha"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="dates" range @change="validateDates" scrollable>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
      <v-btn text color="primary" @click="saveDates">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
      dates: [],
      dateRangeText: "",
    };
  },
  methods: {
    validateDates() {
      if (this.dates.length === 2) {
        const [start, end] = this.dates;
        if (start > end) {
          this.dates = [start, start];
        }
        this.updateDateRangeText();
      }
    },
    updateDateRangeText() {
      if (this.dates.length === 2) {
        const [start, end] = this.dates;
        this.dateRangeText = `${start} - ${end}`;
      } else {
        this.dateRangeText = "";
      }
    },
    saveDates() {
      if (this.dates.length === 2) {
        this.$emit("dates-selected", this.dates);
      }
      this.menu = false;
    },
  },
};
</script>

<style scoped></style>
